import React, { useEffect, useRef } from "react";

// SASS
import "./Part9.scss";

// COMPONENTS
import Step from "../Step/Step";

// HELPERS
import animate from "../../utils/animate";

// LIBRARIES
import scrollama from "scrollama";

// ASSETS
import handHygieneImg from "../../assets/img/hand-hygiene.png";
import cleaningImg from "../../assets/img/environmental-cleaning.png";
import targetImg from "../../assets/img/target.svg";
import germ1Img from "../../assets/img/germ-3-yellow.svg";
import germ2Img from "../../assets/img/germ-2-yellow.svg";
import germ3Img from "../../assets/img/germ-1-yellow.svg";

// FUNCTION EXPORT
export default function Part9({
  step,
  setCurrentVirusPart,
  setShowVirusParts,
}) {
  // SCROLLAMA INSTANCE
  const scrolly = scrollama();

  // ANIMATION STEP DATA
  const animationSequence = [
    { stepNumber: "0", height: null, description: "spacer" },
    {
      stepNumber: "1",
      height: null,
      description: "add moved class to hand hygiene and env cleaning",
    },
    {
      stepNumber: "2",
      height: null,
      description: "fade in middle text and germs container",
    },
    { stepNumber: "4", height: null, description: "move target to germ 1" },
    { stepNumber: "5", height: null, description: "move target to germ 2" },
    { stepNumber: "6", height: null, description: "move target to germ3" },
    { stepNumber: "7", height: null, description: "spacer" },
    {
      stepNumber: "8",
      height: null,
      description:
        "change background-color to white, change showVirusParts to false",
    },
  ];

  // REFS
  const handHygieneEl = useRef(null);
  const cleaningEl = useRef(null);
  const middleTextEl = useRef(null);
  const germsContainerEl = useRef(null);
  const part9El = useRef(null);
  const targetEl = useRef(null);
  const germ1El = useRef(null);
  const germ2El = useRef(null);
  const germ3El = useRef(null);

  const handHygieneElDesktop = useRef(null);
  const cleaningElDesktop = useRef(null);
  const middleTextElDesktop = useRef(null);
  const germsContainerElDesktop = useRef(null);
  const targetElDesktop = useRef(null);
  const germ1ElDesktop = useRef(null);
  const germ2ElDesktop = useRef(null);
  const germ3ElDesktop = useRef(null);

  // RUN WHEN THE COMPONENT MOUNTS
  useEffect(() => {
    scrolly
      .setup({
        step: `.${step}`,
        debug: false,
        threshold: 1,
        progress: true,
      })
      .onStepEnter(({ element, direction }) => {
        const step = element.dataset.step;
        switch (step) {
          case "1": {
            animate.removeClassOnEnter(
              handHygieneEl.current,
              "moved",
              direction
            );
            animate.removeClassOnEnter(cleaningEl.current, "moved", direction);

            animate.removeClassOnEnter(
              handHygieneElDesktop.current,
              "moved",
              direction
            );
            animate.removeClassOnEnter(
              cleaningElDesktop.current,
              "moved",
              direction
            );
            break;
          }
          case "2": {
            animate.fadeInOnEnter(middleTextEl.current, direction);
            animate.fadeInOnEnter(germsContainerEl.current, direction);

            animate.fadeInOnEnter(middleTextElDesktop.current, direction);
            animate.fadeInOnEnter(germsContainerElDesktop.current, direction);
            break;
          }
          case "4": {
            animate.addClassOnEnter(targetEl.current, "target-1", direction);
            setTimeout(() => {
              animate.addClassOnEnter(germ2El.current, "wiggle", direction);
            }, 200);

            animate.addClassOnEnter(
              targetElDesktop.current,
              "target-1",
              direction
            );
            setTimeout(() => {
              animate.addClassOnEnter(
                germ2ElDesktop.current,
                "wiggle",
                direction
              );
            }, 200);
            break;
          }
          case "5": {
            animate.addClassOnEnter(targetEl.current, "target-2", direction);
            setTimeout(() => {
              animate.addClassOnEnter(germ1El.current, "wiggle", direction);
            }, 200);

            animate.addClassOnEnter(
              targetElDesktop.current,
              "target-2",
              direction
            );
            setTimeout(() => {
              animate.addClassOnEnter(
                germ1ElDesktop.current,
                "wiggle",
                direction
              );
            }, 200);
            break;
          }
          case "6": {
            animate.addClassOnEnter(targetEl.current, "target-3", direction);
            setTimeout(() => {
              animate.addClassOnEnter(germ3El.current, "wiggle", direction);
            }, 200);

            animate.addClassOnEnter(
              targetElDesktop.current,
              "target-3",
              direction
            );
            setTimeout(() => {
              animate.addClassOnEnter(
                germ3ElDesktop.current,
                "wiggle",
                direction
              );
            }, 200);
            break;
          }
          case "8": {
            animate.fadeOutOnEnter(part9El.current, direction);
            animate.changeBodyBgColorDown("#FFFFFF", direction);
            if (direction === "down") setShowVirusParts(false);
            if (direction === "down") setCurrentVirusPart(null);
            break;
          }
          default:
            break;
        }
      })
      .onStepProgress(({ element, progress }) => {
        const step = element.dataset.step;
        switch (step) {
          default:
            break;
        }
      })
      .onStepExit(({ element, direction }) => {
        const step = element.dataset.step;
        switch (step) {
          case "1": {
            animate.addClassOnExit(handHygieneEl.current, "moved", direction);
            animate.addClassOnExit(cleaningEl.current, "moved", direction);

            animate.addClassOnExit(
              handHygieneElDesktop.current,
              "moved",
              direction
            );
            animate.addClassOnExit(
              cleaningElDesktop.current,
              "moved",
              direction
            );
            break;
          }
          case "2": {
            animate.fadeOutOnExit(middleTextEl.current, direction);
            animate.fadeOutOnExit(germsContainerEl.current, direction);

            animate.fadeOutOnExit(middleTextElDesktop.current, direction);
            animate.fadeOutOnExit(germsContainerElDesktop.current, direction);
            break;
          }
          case "4": {
            animate.removeClassOnExit(targetEl.current, "target-1", direction);
            animate.removeClassOnExit(germ2El.current, "wiggle", direction);

            animate.removeClassOnExit(
              targetElDesktop.current,
              "target-1",
              direction
            );
            animate.removeClassOnExit(
              germ2ElDesktop.current,
              "wiggle",
              direction
            );
            break;
          }
          case "5": {
            animate.removeClassOnExit(targetEl.current, "target-2", direction);
            animate.removeClassOnExit(germ1El.current, "wiggle", direction);

            animate.removeClassOnExit(
              targetElDesktop.current,
              "target-2",
              direction
            );
            animate.removeClassOnExit(
              germ1ElDesktop.current,
              "wiggle",
              direction
            );
            break;
          }
          case "6": {
            animate.removeClassOnExit(targetEl.current, "target-3", direction);
            animate.removeClassOnExit(germ3El.current, "wiggle", direction);

            animate.removeClassOnExit(
              targetElDesktop.current,
              "target-3",
              direction
            );
            animate.removeClassOnExit(
              germ3ElDesktop.current,
              "wiggle",
              direction
            );
            break;
          }

          case "8": {
            animate.fadeInOnExit(part9El.current, direction);

            if (direction === "up") setShowVirusParts(true);
            setTimeout(() => {
              if (direction === "up") setCurrentVirusPart("envelope");
              animate.changeBodyBgColorUp("#A74920", direction);
            }, 0);

            break;
          }
          default:
            break;
        }
      });
  }, [scrolly, step]);

  // CUSTOM FUNCTIONS

  return (
    <section className="wrapper">
      <div className="sticky-container">
        {/* STICKY */}
        <div className="part9" ref={part9El}>
          <div className="part9__container-mobile">
            <div className="text text-top">
              The envelope is important when it comes to
            </div>
            <div className="photos-container">
              <div className="hand-hygiene moved" ref={handHygieneEl}>
                <img src={handHygieneImg} alt="" className="img-fluid" />
              </div>
              <div className="cleaning moved" ref={cleaningEl}>
                <img src={cleaningImg} alt="" className="img-fluid" />
              </div>
            </div>
            <div className="text text-middle" ref={middleTextEl}>
              because cleaning <b>destroys</b> the envelope protecting the
              virus.
            </div>
            <div className="germs-container" ref={germsContainerEl}>
              <div className="germ germ-1 rotate" ref={germ1El}>
                <img src={germ1Img} alt="" className="img-fluid" />
              </div>
              <div className="germ germ-2 rotate" ref={germ2El}>
                <img src={germ2Img} alt="" className="img-fluid" />
              </div>
              <div className="germ germ-3 rotate" ref={germ3El}>
                <img src={germ3Img} alt="" className="img-fluid" />
              </div>
              <div className="target" ref={targetEl}>
                <img src={targetImg} alt="" className="img-fluid" />
              </div>
            </div>
          </div>
          <div className="part9__container-desktop">
            <div className="part9__photos-container">
              <div className="text text-top">
                The envelope is important when it comes to
              </div>
              <div className="photos-container">
                <div className="hand-hygiene moved" ref={handHygieneElDesktop}>
                  <img src={handHygieneImg} alt="" className="img-fluid" />
                </div>
                <div className="cleaning moved" ref={cleaningElDesktop}>
                  <img src={cleaningImg} alt="" className="img-fluid" />
                </div>
              </div>
            </div>
            <div className="part9__virus-container">
              <div className="text text-middle" ref={middleTextElDesktop}>
                because cleaning <b>destroys</b> the envelope protecting the
                virus.
              </div>
              <div className="germs-container" ref={germsContainerElDesktop}>
                <div className="germ germ-1 rotate" ref={germ1ElDesktop}>
                  <img src={germ1Img} alt="" className="img-fluid" />
                </div>
                <div className="germ germ-2 rotate" ref={germ2ElDesktop}>
                  <img src={germ2Img} alt="" className="img-fluid" />
                </div>
                <div className="germ germ-3 rotate" ref={germ3ElDesktop}>
                  <img src={germ3Img} alt="" className="img-fluid" />
                </div>
                <div className="target" ref={targetElDesktop}>
                  <img src={targetImg} alt="" className="img-fluid" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* STEPS */}
      {animationSequence.map(({ stepNumber, height, description, offset }) => {
        return (
          <Step
            stepSection={step}
            stepNumber={stepNumber}
            stepDescription={description}
            height={height}
            key={stepNumber}
            offset={offset}
          />
        );
      })}
    </section>
  );
}
